import { useNavigate } from "react-router-dom";
import { appPaths } from "../../Routes";
import { useEdeclaration } from "../../api/edeclaration";
import { successToast, errorToast } from "../../toast";
import { useUpdateDriverDeclarationType } from "../../api/admin/driver";
import { ApiUpdateDriverDeclarationTypeDto } from "../../models/api/admin/driver";
import { DeclarationType } from "../../models/app/eDeclarations";

const useDriverDeclarationsTable = (refetchEDeclarationsList: () => void) => {
    const navigate = useNavigate();
    const { sendInstantDeclarationInviteEmail } = useEdeclaration();

    // Click handlers:
    const declarationRequestAction = async (declarationId: string) => {
        const response = await sendInstantDeclarationInviteEmail(declarationId);

        if (response.success) {
            successToast("E-Declaration request sent");
            refetchEDeclarationsList();
        } else {
            errorToast("Error sending E-Declaration request");
        }
    };

    const editDriverClickHandler = (driverId?: string) => {
        if (driverId) navigate(appPaths.adminEditDriver(driverId));
    };

    const [updateDeclarationType, isUpdatingDeclarationType] =
        useUpdateDriverDeclarationType();

    const switchDeclarationTypeAction = async (
        declarationId: string,
        declarationType: DeclarationType
    ) => {
        const dto: ApiUpdateDriverDeclarationTypeDto = {
            declarationType,
        };
        const response = await updateDeclarationType({
            declarationId: declarationId,
            dto,
        });
        if (response.success) {
            successToast("Declaration type updated");
            refetchEDeclarationsList();
        } else {
            errorToast("Error updating declaration type");
        }
    };

    return {
        refetchEDeclarationsList,
        switchDeclarationTypeAction,
        isUpdatingDeclarationType,
        editDriverClickHandler,
        declarationRequestAction,
    };
};

export default useDriverDeclarationsTable;
